import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
//import { Switch, FormControlLabel, FormGroup } from '@mui/material';
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { BindReportGrid, OpenBase64Pdf, ReverseFormatDate, exportToExcel, formatDate, getBeforeDate, setFocus, setTitle } from "../Common/Common";
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from '../Layout/Loader';


const EmptyReport = ({ open, setOpen }) => {
    const navigate = useNavigate();
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    //const SalesPersonCode = cookies.get('salesPersonCode')
    const [isUpdate, setIsUpdate] = useState(false)
    //const [salesPerson, setSalesPerson] = useState([]);
    const [MenuText, setMenuText] = useState("Request Report");
    const [isLoading, setIsLoading] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [tableData, setTableData] = useState({})
    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
        DateFrom:"",
        DateTo: "",
        WareHouse: '',
        //Summary:true,
    });
    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }
    useEffect(() => {
        setFocus('txtWareHouse')
        setTitle('EmptyReport', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])
    
    //useEffect(() => {
    //    GetDate();
    //}, [FilterData.PageIndex, isUpdate]);

    //const [summarySwitch, setSummarySwitch] = useState(false);

    //const handleSummaryToggle = (event) => {
    //    const isChecked = event.target.checked;
    //    setSummarySwitch(isChecked); 
    //    const loginCodeString = String(LoginUserCode);
    //    const data = {
    //        ...FilterData,
    //        isSummary: isChecked,
    //        Source: "Toggle",
    //        Token,
    //        LoginUserCode: loginCodeString
    //    };

    //    setIsLoading(true);

    //    post(`${API_SERVER}`, data, (res) => {
    //        if (res.message === 'EXPIRED') {
    //            navigate('/Login');
    //        }
    //        else if (res.status === 'SUCCESS') {
    //            console.log('Summary toggle success:', res);
    //            // Optional: You can show success notification here
    //        }
    //        else if (res.status === 'ERROR' || res.message !== '') {
    //            AlertBox(res.status, res.message, res.focus);
    //        }

    //        if (res.focus !== "") {
    //            setFocus(res.focus);
    //        }

    //        setIsLoading(false);
    //    });
    //};




    const GetDate = (Type = 'S', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowEmptyReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'EmptyReport');
                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]
                    })
            }
            setIsLoading(false)
        })
    }

    const handleChange1 = (event, value) => {
        GetDate("S", value);
    };
    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                DateFrom: "",
                DateTo: "",
                WareHouse: '',
                Summary:'',
            }
        );
        setTableData(
            {
                totalRecord: 0,
                gridData: [{
                }]
            })
        setIsUpdate(!isUpdate)
        setFocus('txtWareHouse');
    }
    const [WarehouseData, setWarehouseData]= useState([])

   
    const getWarehouseData = () => {
        setWarehouseData([]);
        let temp = {
            Type: "GetWarehouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let warehouseData = res.autoCompleteData || [];
                setWarehouseData(warehouseData);
            } else {
                setWarehouseData([]);
            }
        });
    };
    const handlePrintData = (ID) => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData,
            Source: "Report",
            Summary: true,
            Token,
            LoginUserCode: loginCodeString
        };
        setIsLoading(true)
        post(`${API_SERVER}/api/Print/EmptyReportPrint`, { ...data }, (res) => {
            if (res.message === 'EXPIRED') {
                navigate('/Login')
            }
            else if (res.status === 'SUCCESS') {
                console.log(res, "resresres")
                OpenBase64Pdf(res.documentPdfBase64, 'EmptyReport_' + ID, '_blank');
            }
            if (res.status === 'ERROR' || res.message !== '') {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false)
        });
    }

    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        GetDate();
    }
    let WarehouseArr = []
    for (let i = 0; i < WarehouseData.length; i++) {
        let mydata = WarehouseData[i]?.values
        WarehouseArr.push(mydata)
    };
    //const handleDownloadExcel = async () => {
    //    GetDate('E');
    //}

    useEffect(() => {
        if (FilterData.DateFrom) {
            const fromDateObj = new Date(FilterData.DateFrom);
            const toDateObj = new Date(FilterData.DateTo);

            if (
                !FilterData.DateTo ||
                toDateObj <= fromDateObj
            ) {
                const nextDay = new Date(fromDateObj);
                nextDay.setDate(fromDateObj.getDate() + 1);

                const formattedNextDay = formatDate(nextDay);

                setFilterData(prev => ({
                    ...prev,
                    DateTo: formattedNextDay
                }));
            }
        }
    }, [FilterData.DateFrom]);

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                               
                                    <div className="row align-items-end">

                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <AutoCompleteBox
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("txtDateFrom") };
                                                    }}
                                                    label='WareHouse'
                                                    placeholder="WareHouse"
                                                    maxLength='50'
                                                    options={WarehouseArr}
                                                    id='txtWareHouse'
                                                    required={true}
                                                    ignore_common={true}
                                                    onFocus={() => getWarehouseData()}
                                                    inputValue={FilterData.WareHouse || ''}
                                                    onInputChange={(event, newInputValue) => {
                                                        HandleChange('WareHouse', newInputValue)
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">From Date</label>
                                                <DatePicker
                                                selected={ReverseFormatDate(FilterData.DateFrom) || null}
                                                    id='txtDateFrom'
                                                    className="form-control"
                                                    placeholderText='From Date'
                                                    dateFormat={'dd-MMM-yyyy'}
                                                    autoComplete='off'
                                                    onChange={(date) => {
                                                        setFilterData({ ...FilterData, DateFrom: formatDate(date) })
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            setFocus('chkSummary')
                                                        };
                                                    }}
                                                    maxDate={new Date()}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">To Date</label>
                                            <DatePicker
                                                selected={ReverseFormatDate(FilterData.DateTo) || null}
                                                className="form-control"
                                                id="txtDateTo"
                                                placeholderText='To Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setFilterData({ ...FilterData, DateTo: formatDate(date) })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('')
                                                    };
                                                }}
                                                minDate={new Date(FilterData.DateFrom)}
                                                maxDate={new Date()} 
                                            />
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="form-check form-switch">
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="activeCheckbox"
                                                >
                                                   Summary
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="chkSummary"
                                                    name='Summary'
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            setFocus('btnSearch')
                                                        };
                                                    }}
                                                    checked={FilterData.Summary}
                                                    onChange={(e) => {
                                                        setFilterData({
                                                            ...FilterData, Summary: e.target.checked
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </div>

                                       
                                        <div className="col-lg-12 mt-1">
                                            <div className="lms-new-button text-center">
                                                <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                    <i className="bi bi-search" /> Search
                                                </button>
                                                <button className="button print-btn" onClick={handlePrintData} >
                                                    <i className="bi bi-printer" /> Print
                                                </button>
                                                <button className="button reset-btn" onClick={handleClearData} >
                                                    <i className="bi bi-arrow-clockwise" /> Reset
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid
                tableData={tableData}
                setFilterData={setFilterData}
                filterData={FilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1} />
            {isLoading ?
                <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default EmptyReport